module.exports = __webpack_public_path__ + "static/media/products_default.66dd4224.jpg";